import React, { useState, Fragment, Component } from 'react'
import PenilaianBloc from "../Blocs/PenialianBloc"
import { config } from "../../../../../helpers/config_global"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/penilaian360Service'
import apiResponse from '../../../../../services/apiResponse'
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import CustomSelect from "../../../../../helpers/ui/CustomSelect"
import moment from "moment"
import { Redirect } from "react-router-dom"
import 'moment/locale/id'
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    Tooltip,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label
} from "reactstrap"

class IndexPeriodComponent extends Component 
{
    penilaianBloc = new PenilaianBloc();

    source
    historyTable = 'periodePenialianRecap360Active'
    defaultOrder = 'ms360_period_date_start'
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
 

    constructor(props) {
        super(props)
        this.state = {
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: moment().endOf('month').format('YYYY-MM-DD'),
            work_unit_uuid: "all",
            work_units: [],
            loadingWorkUnit: false,
            startUuid: "",
            periodUuid: "",
            inactiveUuid: "",
            dataForm: {},
            obj: null,
            modalShow: false,
            modalToggle: false,
            tooltip: false,  
            detailUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            date_start: this.state.date_start,
            date_end: this.state.date_end,
            work_unit_uuid: this.state.work_unit_uuid
        }

        await this.penilaianBloc.fetchRecapPeriod(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    loadOrganization = async () => {
        await this.penilaianBloc.fetchOrganization({})
    }

    componentDidMount() {

        this.setTokenAPI()
        this.loadOrganization()

        this.penilaianBloc.recapPeriodListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.penilaianBloc.recapOrganizationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingWorkUnit: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingWorkUnit: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const opts = [
                        { label: 'Semua Unit Kerja', value: 'all' },
                        ...Object.values(response.organizations)
                    ];
                    this.setState({
                        work_units: opts
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

    }


    columns = [
        {
            key: "ms360_period_date_start",
            text: "PERIODE AWAL",
            className: "ms360_period_date_start",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_start != null) ? moment(record.ms360_period_date_start).format('DD MMMM YYYY') : '-';
            }
        },
        {
            key: "ms360_period_date_end",
            text: "PERIODE AKHIR",
            className: "ms360_period_date_end",
            sortable: true,
            cell: record => {
                return (record.ms360_period_date_end != null) ? moment(record.ms360_period_date_end).format('DD MMMM YYYY') : '-';
            }
        },
        {
            key: "ms360_team_work_unit_name",
            text: "UNIT KERJA",
            className: "ms360_team_work_unit_name",
            sortable: true,
        },
        {
            key: "ms360_team_alias",
            text: "ALIAS",
            className: "ms360_team_alias",
            sortable: true,
        },
         {
            key: "ms360_period_id",
            text: "PERSENTASE",
            className: "ms360_period_id",
            sortable: false,
            align: 'center',
            cell: record => {
                const total_member = parseInt(record.total_member);
                const total_assign = parseInt(record.total_assign);
                if(total_member > 0){
                    const percentage = (parseFloat(total_assign) / parseFloat(total_member) * 100)
                    if(parseFloat(percentage) >= 100){
                        return (<span className="badge bg-success">{`${parseFloat(percentage).toFixed(2)} %`}</span>)
                    }else{
                        return (<span className="badge bg-primary">{`${parseFloat(percentage).toFixed(2)} %`}</span>)
                    }
                }else{
                    return (<span className="badge bg-danger">{'0.00 %'}</span>)
                }                
            }
        },
        {
            key: "ms360_period_id",
            text: "STATUS",
            className: "ms360_period_id",
            sortable: false,
            align: 'center',
            cell: record => {
                const startDate = record.ms360_period_date_start;
                const endDate = record.ms360_period_date_end;
                const today = moment().startOf('day');
                const start = moment(startDate).startOf('day');
                const end = moment(endDate).endOf('day');
                if (today.isBefore(start)) {
                    return (<span className="badge bg-warning">{'Pending'}</span>)
                }else if (today.isAfter(end)) {
                    return (<span className="badge bg-danger">{'Berakhir'}</span>)
                }else{
                    return (<span className="badge bg-success">{'Berlangsung'}</span>)
                }
            }
        },
        {
            key: "action",
            text: "AKSI",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
               const thisId = record.ms360_period_uuid
               return (
                  <Fragment>
                    <span>
                        <button 
                            className="btn btn-success btn-sm" 
                            id={"detail-" + thisId}
                            onClick={() => {
                                this.setState({
                                    detailUuid: `${record.ms360_period_uuid}&team_uuid=${record.ms360_team_uuid}`,
                                    startUuid: null
                                })
                            }}
                            style={{
                                marginRight: '2px',
                                padding: '2px 5px'
                            }}>
                            <i className="uil-search"></i>
                        </button>
                        <Tooltip
                            style={{
                                marginBottom: 2
                            }}
                            placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                            toggle={() => {
                                this.setState({
                                    ["detail" + thisId] : !this.state["detail" + thisId]
                                })
                            }}
                        >Lihat Detail</Tooltip>
                    </span>
                  </Fragment>
               )
            }
        }
    ]


    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            date_start: values.date_start,
            date_end: values.date_end,
            work_unit_uuid: values.work_unit_uuid
        })
        setTimeout(() =>  { 
            this.setTokenAPI()
        }, 500)
    }

    componentWillUnmount(){
        this.penilaianBloc.recapPeriodListChannel.unsubscribe()
        this.penilaianBloc.recapOrganizationChannel.unsubscribe()
    }

    render(){
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <Card className="">
                                <CardBody>
                                    <CardTitle>Daftar Penialian 360 </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Kelola Penialian 360 
                                    </CardSubtitle>
                                    <hr />
                                     <div className='mb-4 mt-2'>
                                        <div className='row'>
                                            <div className='col-md-7'>
                                                <AvForm
                                                    className="needs-validation"
                                                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                                >
                                                    <div className="row mb-3">
                                                        <label for="" className="col-sm-2 col-form-label">
                                                            Periode Awal
                                                        </label>
                                                        <div className="col-sm-4">
                                                             <AvField
                                                                isAvForm={true}
                                                                name="date_start"
                                                                placeholder="Periode Awal"
                                                                errorMessage="Masukkan Periode Awal"
                                                                type="date"
                                                                className="form-control"
                                                                id="date_start"
                                                                validate={{ required: { value: true } }}
                                                                defaultValue={this.state.date_start}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label for="" className="col-sm-2 col-form-label">
                                                            Periode Akhir
                                                        </label>
                                                        <div className="col-sm-4">
                                                            <AvField
                                                                isAvForm={true}
                                                                name="date_end"
                                                                placeholder="Periode Akhir"
                                                                errorMessage="Masukkan Periode Akhir"
                                                                type="date"
                                                                className="form-control"
                                                                id="date_end"
                                                                validate={{ required: { value: true } }}
                                                                defaultValue={this.state.date_end}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <label for="" className="col-sm-2 col-form-label">
                                                            Unit Kerja
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <CustomSelect 
                                                                isAvForm={true}
                                                                name={`work_unit_uuid`}
                                                                id={`work_unit_uuid`}
                                                                errorMessage="Pilih Filter Unit Kerja"
                                                                options={this.state.work_units} 
                                                                validate={{ required: { value: false } }}
                                                                placeholder="Pilih Filter Unit Kerja"
                                                                isLoading={this.state.loadingWorkUnit}
                                                                defaultValue={this.state.work_unit_uuid}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-sm-9  offset-sm-2">
                                                            <button className="btn btn-primary" type='submit' disabled={this.state.work_units.length === 0}>
                                                                 <i className="uil-search-alt"></i> Filter Pencarian
                                                            </button>
                                                        </div>
                                                    </div>
                                                </AvForm>
                                            </div>
                                        </div>
                                    </div>
                                    <MKIDatatable
                                        className={this.configDatatable.tableClass}
                                        config={this.configDatatable}
                                        records={this.state.rows}
                                        columns={this.columns}
                                        dynamic={true}
                                        minWidth={1000}
                                        total_record={this.state.totalRow}
                                        initial={this.state.filter}
                                        onChange={(filter) => {
                                            this.setState({
                                                loadingTable: true,
                                                filter: filter
                                            }, function () {
                                                this.setTokenAPI()
                                            });
                                        }}
                                        loading={this.state.loadingTable}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                { this.state.detailUuid !== null ?
                    <Redirect to={"/kepegawaian/rekap360.html?section=detail&uuid=" + this.state.detailUuid}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexPeriodComponent